import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../redux/registrationPopupActions';
import styles from 'src/styles/AuthPopup.scss';
import PopoverTrigger from 'src/components/popover/PopoverTrigger';
import RegistrationInputTimer from './RegistrationInputTimer';
import cx from 'classnames';
import {canResetPasswordResendTimestamp} from 'src/logic/utils';
import {findDOMNode} from 'react-dom';
import fm from 'src/logic/formatMessage';
import {hashPassword} from 'src/logic/authHelpers';
import {
  Input,
  Button,
  Col,
  Row
} from 'src/components/Common/reactstrap/lib';
class RegistrationInputSecondStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }

  submitPassword = (e) => {
    e.preventDefault();
    this.props.submitPassword(hashPassword(this.refs.passwordInput.value));
  };

  render() {
    const {sentPasswordErr, returnToFirstStep} = this.props;
    const passwordInputContainerClassName = {
      [styles.input]: true,
      'input-text': true,
      [styles.invalidInput]: !!sentPasswordErr
    };
    return (
      <form
        onSubmit={this.submitPassword}
        className={styles.inputContainer}>
        <Row className={styles.phoneInputContainer}>
          <Col sm="6">
          <PopoverTrigger
            content={fm(this.props.sentPasswordErr)}
            placement="left">
            <input
              ref="passwordInput"
              required
              type="password"
              placeholder="Введите код из SMS"
              className={cx(passwordInputContainerClassName)}/>
          </PopoverTrigger>
          </Col>
          <RegistrationInputTimer />

        </Row>

        <a onClick={returnToFirstStep} className="link">Изменить номер телефона</a>

        <div className="py-2">
          <button className="btn-brand btn-wide">Подтвердить</button>
        </div>
      </form>
    );

  }
}

export default connect(
  (state) => ({...state.registrationPopupReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(RegistrationInputSecondStep);



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/elements/RegistrationInputSecondStep.jsx
 **/